import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { SessionStore, UserView } from '../types/store/SessionStore';
import { LoginResponse } from '../types/auth';
import { UserPreferences } from '../types/ui';

const initialState: SessionStore = JSON.parse(localStorage.getItem("session") || "{}");

const Session = createSlice({
  name: 'session',
  initialState,
  reducers: {
    setSessionLogin: (state, action: PayloadAction<LoginResponse>) => {
      state.accessToken = action.payload.accessToken;
      state.isAdministrator = action.payload.isAdministrator;
      state.isManager = action.payload.isManager;
      state.email = action.payload.email;
      state.name = action.payload.name;
      state.profiles = action.payload.profiles;
      state.role = action.payload.role;
      state.sessionId = action.payload.sessionId;
      state.userId = action.payload.userId;
      state.accountId = action.payload.accountId;
      state.accountName = action.payload.accountName;
      state.preferences = action.payload.userPreferences?.preferences;
      localStorage.setItem('session', JSON.stringify(state));
    },
    setCurrentView: (state, action: PayloadAction<UserView | null>) => {
      state.currentView = action.payload;
      localStorage.setItem('session', JSON.stringify(state));
    },
    resetSessionAuth: (state) => {
      state.accessToken = undefined;
      state.isAdministrator = false;
      state.isManager = false;
      state.email = undefined;
      state.name = '';
      state.profiles = undefined;
      state.role = undefined;
      state.sessionId = 0;
      state.userId = 0;
      state.accountId = 0;
      state.accountName = undefined;
      state.currentView = null;
      localStorage.removeItem('session');
    },
    setSessionPreferences: (state, action: PayloadAction<UserPreferences>) => {
      state.preferences = action.payload;
      localStorage.setItem('session', JSON.stringify(state));
    },
  },
});

export const { setSessionLogin, setCurrentView, resetSessionAuth, setSessionPreferences } = Session.actions;

export default Session.reducer;
